<template>
  <div>
    <div class="mx-auto grid grid-cols-1 gap-4 lg:grid-cols-2">
      <CategoryBox
        v-for=" block in blocks"
        :key="block.header"
        :header="block.header"
        :description="block.description"
        :button-text="block.buttonText"
        :image="block.image"
        :alt="block.alt"
        :link="block.link"
      />
    </div>
  </div>
</template>
<script lang="ts">
import CategoryBox from '~/components/molecules/CategoryBox/CategoryBox.vue';
import type { CategoryBox as CategoryBoxType } from '~~/types/cms/CategoryBox';
export default defineComponent({
  name: 'CategoryBoxes',
  components: {
    CategoryBox,
  },
  props: {
    blocks: {
      type: Array as PropType<CategoryBoxType[]>,
      default: () => {

        return [];
      
      },
      validator: (uspItems: CategoryBoxType[]) => {

        return uspItems.every((block: CategoryBoxType) => {

          return block.header && block.description && block.buttonText && block.image && block.alt && block.link;
        
        });
      
      },
    },
  },
});
</script>
